<template lang="pug">

.questions
  //.title-1 常见问题
  //.dropdown
    .select-box(@click="toggleDropdown")
      span.bold {{title[selected]}}
      .arrow
        icon-arrow

    .drop-list
      .shadow-layer(ref="opshadow")
      .options(ref="ops" v-for="op in options" @click="optionSelect(op)") {{title[op]}}

  //img.copy(src="~assets/ui/menu/qacopy.png")
  .upper
    .qa-title 常见问题
  .bottom
    .swiper-container(id="qa-content")
      .swiper-wrapper
        .swiper-slide.qa-content
          .section.section-1
            .qa-subtitle 加州天气
            .qa-line
            .qa-copy 加利福尼亚四季皆宜出行，无论你喜欢阳光还是雪，都能找到适合您的最佳游览时机。因为早晚温差较大，别忘了随身携带羊毛衫和防风的保暖外套。无论任何季节前往旧金山的游客，请一定记得带上您的羽绒服。此外，太阳镜、充足的防晒霜、和遮阳帽必不可少。
          .section.section-2
            .qa-subtitle 加州租车
            .qa-line
            .qa-copy 在加利福尼亚州自驾旅行非常普遍且方便，您可以在机场的到达大厅车铺租到车辆，租车行都提供异地还车服务。中国有效驾照可在美国使用。租车时需持有本人的有效护照和信用卡。英文不好的朋友，建议从国内携带中文的GPS汽车导航仪。
          .section.section-3
            .qa-subtitle 加州游客中心
            .qa-line
            .qa-copy 众多游客中心遍布加州各地，游客中心有工作人员随时为您提供旅游服务，还有当地旅游专家和内行人士分享更多建议，包括推荐用餐、观光、住宿等旅游信息，让您的行程更完美、更丰富。游客中心也会提供与当地景区和当地休闲活动相关的免费地图和手册。

          .swiper-slide.blank




</template>

<script>
  import IconArrow from 'src/components/vca/widgets/IconArrow'
  import {TweenMax, TimelineMax, Power3, Back} from 'gsap'
  import { Swiper } from 'swiper/dist/js/swiper.esm.js'
export default {
  name: 'questions',
  components: {
    IconArrow
  },
  data() {
    return {
      selected: 0,
      options: [0,1,2],
      title: [
        '出游时机',
        '选项二',
        '选项三',
      ],
      copy: [
        '出游时机出游时机出游时机出游时机出游时机出游时机',
        '选项二选项二',
        '选项三选项三'
      ],
      listDropped: false,
      animating: false

    }
  },
  props: {},
  computed: {},
  mounted() {



    this.swiper = new Swiper('#qa-content', {
      direction: 'vertical',
      slidesPerView: 'auto',
      slidesOffsetAfter: 80,
      spaceBetween: 0,
      freeMode: true
    })
  },
  beforeDestroy() {},
  methods: {
    init(){

    },
    toggleDropdown(){
      if(!this.animating){
        if(this.listDropped){
          this.closeList()
        }else{
          this.dropList()
        }
      }
    },
    dropList(){
      this.animating = true
      let tl = new TimelineMax({
        onComplete: () => {
            this.animating = false
            this.listDropped = true
        },
        onReverseComplete: () => {
          this.animating = false
          this.listDropped = false
        }
      })
      this.tl = tl

      tl.add('start')
        .to(
          this.$refs.opshadow,
          0.3,
          {
            opacity: 1,
            ease: Power3.easeOut
          },
          `start+=0`
        )
        .staggerTo(
          this.$refs.ops,
          0.2,
          {
            y: 0,
            opacity: 1,
            ease: Back.easeOut.config(1.7),
          },
          0.1,
          `start+=0`
        )
    },
    closeList(){
      this.animating = true
      this.tl.reverse()
    },
    optionSelect(op){
      this.selected = op
      this.closeList()
    }
  },
  watch: {},
}
</script>

<style lang="sass">
@import "src/styles/common.sass"
.questions
  //color: white

  width: 100%
  height: 100%
  //background: #ffd81b
  line-height: 0
  //img
    display: block
  //.section
    transform: scale(0.5)
    opacity: 0
  .section
    transform: scale(0.5)
    transform-origin: top right
    opacity: 0
  &.active
    .section
      transform: scale(1)
      opacity: 1
      transition-property: all
      transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1)
      transition-duration: 0.6s
    .section-1
      transition-delay: 0.8s
    .section-2
      transition-delay: 0.9s
    .section-3
      transition-delay: 1s
  .upper
    margin: auto
    width: 80%
    height: 10%
    //background: rgba(225, 81, 37, 0.51)
    position: relative
    .qa-title
      //width: 30%
      color: white
      font-size: $fs-m
      line-height: $fs-m
      //bottom: 0.1rem

  $contentW: 80vw
  $contentRatio: 941/241
  .bottom
    position: relative
    width: 80%
    height: 90%
    margin: auto
    //background: rgba(58, 96, 46, 0.47)
    z-index: 999
    #qa-content
      width: 100%
      height: 100%


    .blank
      width: 100%
      height: 1rem
    .qa-content
      //background: #f5ff48
      width: 100%
      height: auto
      line-height: $fs-s*2
      //width: $contentW
      //height: $contentW*$contentRatio
      position: relative
      //margin-bottom: 3rem


      .qa-subtitle
        //width: 50%
        font-size: $fs-l
        color: $cl-lightGold
        margin-bottom: 0.15rem
        letter-spacing: 0.04rem
      .qa-line
        width: 0.3rem
        height: 2px
        border-bottom: 2px $cl-yellow solid
        margin-bottom: 0.3rem
      .qa-copy
        font-size: $fs-xs
        color: white
        margin-bottom: 0.3rem




  //.title-1
    font-size: 0.2rem
    margin-bottom: 0.5rem


  //.copy
    width: 85%
    object-fit: cover
    display: block

  //.dropdown
    position: relative
    width: 85%

    .select-box
      pointer-events: all
      position: relative
      z-index: 20
      width: 100%
      background: white
      height: 5rem
      border-radius: 1rem
      display: flex
      justify-content: space-between
      align-items: center

      span
        color: $cl-yellow
        font-size: 3rem
        margin-left: 2rem
      .arrow
        width: 1.5rem
        margin-right: 1.8rem
        .icon-arrow
          transform-origin: center
          transform: rotateZ(90deg)
          svg
            stroke: $cl-yellow

    .drop-list
      pointer-events: all
      width: 100%
      padding: 0 1rem
      z-index: 10
      position: absolute
      top: 0
      left: 0
      //background-color: white
      //background-clip: content-box
      .shadow-layer
        opacity: 0
        z-index: 15
        position: relative
        width: 100%
        height: 5rem
        box-shadow: 0 3px 5px 0px #dcd9c9
      .options
        z-index: 10
        position: relative
        background: white
        height: 5rem
        color: $cl-yellow
        font-size: 3rem
        text-align: center
        line-height: 5rem
        border: none
        opacity: 0
        transform: translateY(-100%)
        &:active
          background: #d9d9d9

        &:hover
          background: #d9d9d9


















</style>
